class DragToScroll {
    constructor(container) {
        if (!container) {
            throw new Error("A container element is required.");
        }

        this.container = container;
        this.isDragging = false;
        this.startX = 0;
        this.scrollLeft = 0;

        this.handleMouseDown = this.handleMouseDown.bind(this);
        this.handleMouseMove = this.handleMouseMove.bind(this);
        this.handleMouseUp = this.handleMouseUp.bind(this);
        this.handleClick = this.handleClick.bind(this);

        this.container.addEventListener('mousedown', this.handleMouseDown);
        this.container.addEventListener('mouseleave', this.handleMouseUp);
        this.container.addEventListener('mouseup', this.handleMouseUp);
        this.container.addEventListener('mousemove', this.handleMouseMove);
        this.container.addEventListener('click', this.handleClick, true); 

        this.container.style.userSelect = 'none';
        this.container.style.cursor = 'grab';
    }

    handleMouseDown(event) {
        this.isDragging = true;
        this.isClick = true;
        this.startX = event.pageX - this.container.offsetLeft;
        this.scrollLeft = this.container.scrollLeft;
        this.container.style.cursor = 'grabbing';
        event.preventDefault();
    }

    handleMouseMove(event) {
        if (!this.isDragging) return;

        const x = event.pageX - this.container.offsetLeft;
        const walk = (x - this.startX) * 2;
        this.container.scrollLeft = this.scrollLeft - walk;

        if (Math.abs(walk) > 5) {
            this.isClick = false;
        }
    }

    handleMouseUp(event) {
        this.isDragging = false;
        this.container.style.cursor = 'grab';
    }

    handleClick(event) {
        if (!this.isClick) {
            event.preventDefault();
            event.stopImmediatePropagation();
        }
    }

    destroy() {
        this.container.removeEventListener('mousedown', this.handleMouseDown);
        this.container.removeEventListener('mouseleave', this.handleMouseUp);
        this.container.removeEventListener('mouseup', this.handleMouseUp);
        this.container.removeEventListener('mousemove', this.handleMouseMove);
        this.container.removeEventListener('click', this.handleClick, true);
    }
}

function main() {
    document.querySelectorAll('.convx_carousel').forEach(element => {
        const dragToScroll = new DragToScroll(element);
        const progress_bar = document.querySelector('.list-collections .flickity-progress--bar');
        const banner_carousell_progress_bar = document.querySelector('.banner_carousel_slider .list-collections .flickity-progress--bar');
        element.querySelectorAll('img').forEach(img => {
            img.draggable = false;
        });
        element.querySelectorAll('a').forEach(a => {
            a.draggable = false;
        });
        const leftBtn = element.parentElement.querySelector('.flickity-prev');
        const rightBtn = element.parentElement.querySelector('.flickity-next');
        const itemWidth = element.querySelector('.carousel__slide').offsetWidth;
        const visibleItemsCount = Math.floor(element.clientWidth / itemWidth);
        const scrollAmount = (visibleItemsCount / 3) * itemWidth; 
        leftBtn.addEventListener('click', () =>{
            element.scrollTo({
                left: element.scrollLeft - scrollAmount,
                behavior: 'smooth'
            });
        })
        rightBtn.addEventListener('click', () =>{
            element.scrollTo({
                left: element.scrollLeft + scrollAmount,
                behavior: 'smooth'
            });
        })

        element.addEventListener('scroll',() => {
            const min = 0;
            var max = element.scrollWidth - element.clientWidth;
            const progress = Math.max(0, Math.min(1, element.scrollLeft / max)); // Normalize progress (0 to 1)
            // console.log(element.scrollWidth - element.clientWidth - element.scrollLeft)
            if (progress_bar) {
                progress_bar.style.width = `${progress * 100}%`;
            }
          const banner_carousell_progress = Math.max(0.05, Math.min(1, element.scrollLeft / max)); // Normalize progress (0 to 1)
            // console.log(element.scrollWidth - element.clientWidth - element.scrollLeft)
            if (banner_carousell_progress_bar) {
                progress_bar.style.width = `${banner_carousell_progress * 100}%`;
            }
        });
    });
}

main();